import * as React from 'react';
import Pill from './Pill';
const SlideDots = ({ numPills = 0, activeIndex, className, onClick }) => {
    const pills = [];
    for (var i = 0; i < numPills; i++) {
        pills.push(React.createElement(Pill, { key: i, index: i, onClick: () => (onClick ? onClick(i) : undefined), active: activeIndex === i }));
    }
    return React.createElement("div", { className: className }, pills);
};
export default SlideDots;
//# sourceMappingURL=SlideDots.js.map